import {
  AccountDetailsCard,
  AdditionalInfoCard,
  ContactsCard,
  DateAndTimeCard,
  ExtraServicesCard,
  KeysCard,
  NotesCard,
  OrderExtraChargeCard,
  OrderServiceCard,
  OrderStatusCard,
  PackageCard,
  PropertyAddressCard
} from "../Cards";
import { Button, ButtonsGroup, Heading, Link, PageHeader } from "#/atoms";
import { FC, memo, useRef } from "react";
import { FONT_SIZE, NATURAL } from "@/theme";

import { CardHandle } from "../Cards/Cards.interface";
import { ORDER_STATE } from "@/types";
import { OrderProgressProps } from "./Progress.interface";

const Progress: FC<OrderProgressProps> = ({
  addressString,
  appointmentDate,
  appointmentDuration,
  appointmentTime,
  bedrooms,
  coordinator,
  daysToPayInvoices,
  email,
  firstName,
  lastName,
  login,
  phoneNumber,
  contacts,
  contactVendorDirectly,
  customerUserId,
  customerName,
  description,
  doorNumber,
  flat,
  floorArea,
  hasInvoice,
  imageMotionRequested,
  invoiceLink,
  isAdmin,
  keyNotes,
  keys,
  keysTime,
  keysTimeOption,
  keysWith,
  keysWithDetail,
  notes,
  notifyViaSMS,
  offeredServices,
  orderExtraChargeDescription,
  orderExtraChargePriceExVat,
  orderId,
  orderState,
  onAddNote,
  onAskToChangeWorker,
  onAskToEditContact,
  onAskToRemoveContact,
  onAskToAddNewContact,
  onChangeLabel,
  onChangeUrl,
  onChangePackage,
  onChangeRole,
  onConfirmFiles,
  onDeleteFiles,
  onDownloadFiles,
  onGetFloorArea,
  onNavigateToCustomer,
  onNavigateToWorker,
  onRecordFloorArea,
  onRecordVirtualTour,
  onTakeRole,
  onNotifyCustomer,
  onUploadFiles,
  owner,
  parking,
  poNumber,
  selectedOrderTemplate,
  sendNotifications,
  services,
  videoMotionRequested,
  virtualStagingRequested,
  virtualTourPartial
}) => { 
  const accordionState = 'open';

  const accountDetailsRef = useRef<CardHandle>(null);
  const additionalInfoRef = useRef<CardHandle>(null);
  const contactsRef = useRef<CardHandle>(null);
  const dateAndTimeRef = useRef<CardHandle>(null);
  const keysRef = useRef<CardHandle>(null);
  const orderExtraChargeRef = useRef<CardHandle>(null);
  const propertyAddressRef = useRef<CardHandle>(null);

  return (
    <>
      <PageHeader>
        <Heading scale="h1" fontColor={NATURAL.K}>{`Job ${orderId}:`} {description}</Heading>
        <Link fontColor={NATURAL.G} fontSize={FONT_SIZE.LG} style={{marginTop: '12px', order: 3, width: '100%'}} href={`/#/account-customer/id=${customerUserId}`} >{customerName}</Link>
        <ButtonsGroup maxWidth="500px" flexWrap="wrap">
        { hasInvoice && <Link href={invoiceLink} target="_blank">
            <img src='/invoice_active.png'></img>
        </Link> }
          { Number(orderState.value) < ORDER_STATE.COMPLETE &&  <Button actionType='outline' onClick={onChangePackage}>Change Package</Button> }
          <Button onClick={() => onAskToChangeWorker('')}>Assign Photographer for All Services</Button>
          <Button onClick={onNavigateToCustomer}>Customer View</Button>
          <Button onClick={onNavigateToWorker}>Worker View</Button>
        </ButtonsGroup>

      </PageHeader>
      
      <AccountDetailsCard
          accordionState={accordionState}
          daysToPayInvoices={daysToPayInvoices}
          email={email}
          firstName={firstName}
          lastName={lastName}
          login={login}
          phoneNumber={phoneNumber}
          ref={accountDetailsRef}
        />
      { selectedOrderTemplate?.isVirtual || <DateAndTimeCard
        accordionState={accordionState}
        appointmentDate={appointmentDate}
        appointmentTime={appointmentTime}
        appointmentDuration={appointmentDuration}
        contactVendorDirectly={contactVendorDirectly}
        notifyViaSMS={notifyViaSMS}
        ref={dateAndTimeRef}
      /> }

      <OrderStatusCard
          coordinator={coordinator}
          onChangeRole={onChangeRole}
          onTakeRole={onTakeRole}
          orderState={orderState} 
        />
      
      { selectedOrderTemplate?.isVirtual || <PropertyAddressCard
        accordionState={accordionState}
        addressString={addressString}
        flat={flat}
        doorNumber={doorNumber}
        ref={propertyAddressRef}
      /> }

      { selectedOrderTemplate?.isVirtual || <KeysCard
        accordionState={accordionState}
        keys={keys}
        keysTime={keysTime}
        keysTimeOption={keysTimeOption}
        keysWith={keysWith}
        keysWithDetail={keysWithDetail}
        keyNotes={keyNotes}
        ref={keysRef}
      /> }

      { selectedOrderTemplate?.isVirtual || <AdditionalInfoCard
        accordionState={accordionState}
        poNumber={poNumber}
        bedrooms={bedrooms}
        floorArea={floorArea}
        parking={parking}
        virtualTourPartial={virtualTourPartial}
        ref={additionalInfoRef}
      /> }

      <ContactsCard
        accordionState={accordionState}
        contacts={contacts}
        isAdmin={isAdmin}
        onAskToEditContact={onAskToEditContact}
        onAskToRemoveContact={onAskToRemoveContact}
        onNewContact={onAskToAddNewContact}
        ref={contactsRef}
        sendNotifications={sendNotifications}
      />
      <NotesCard
        accordionState={accordionState}
        notes={notes}
        onAddNote={onAddNote}
        owner={owner}
      />

      { selectedOrderTemplate && (
        <PackageCard
          order={selectedOrderTemplate}
        />
      )}
      <OrderServiceCard
          isAdmin={isAdmin}
          logoUrl={''}
          offeredServices={offeredServices}
          onAskToChangeWorker={onAskToChangeWorker}
          onChangeLabel={onChangeLabel}
          onChangeUrl={onChangeUrl}
          onConfirmFiles={onConfirmFiles}
          onDeleteFiles={onDeleteFiles}
          onDownloadFiles={onDownloadFiles}
          onGetFloorArea={onGetFloorArea}
          onNotifyCustomer={onNotifyCustomer}
          onRecordFloorArea={onRecordFloorArea}
          onRecordVirtualTour={onRecordVirtualTour}
          onUploadFiles={onUploadFiles}
          orderId={orderId}
          services={services}
        />
        
      <ExtraServicesCard 
        accordionState={accordionState}
        imageMotionRequested={imageMotionRequested}
        isReadOnly={true}
        videoMotionRequested={videoMotionRequested}
        virtualStagingRequested={virtualStagingRequested}
      />

      <OrderExtraChargeCard
        accordionState={accordionState}
        orderExtraChargeDescription={orderExtraChargeDescription}
        orderExtraChargePriceExVat={orderExtraChargePriceExVat}
        ref={orderExtraChargeRef}
      />
    </>
  );
};

export default memo(Progress);
